export enum ButtonSize {
    S = 's',
    M = 'm',
}

export enum ButtonColor {
    DARK = 'dark',
    LIGHT = 'light',
}
